<div class="about-wizard-page-container container" fxLayout="column" fxLayoutGap="50px">
  <mtn-footer></mtn-footer>
  <div>
    <mtn-key-value-with-placeholder key="Build Number" [value]="buildNumber"></mtn-key-value-with-placeholder>
    <mtn-key-value-with-placeholder key="Revision Number" [value]="commitHash"></mtn-key-value-with-placeholder>
  </div>
  <mtn-full-partner-attribution></mtn-full-partner-attribution>
</div>
